import {matchPath} from 'react-router-dom'
export function studyPeriodHref(studentId:string,enrollmentId:string){
  return `/admin/students/${encodeURIComponent(studentId)}/study-periods/${encodeURIComponent(enrollmentId)}`
}

export function studyPeriodMatch(pathname:string){return matchPath('/admin/students/:userId/study-periods/:enrollmentId',pathname)}
